const FUNNEL_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbzeJLQzU0FXQ4Twfb8yeyrT4qm5fUoygDUoRRU8ydPj-p3ijmulokgBJhnsTirtcWcJcA/exec";

const FUNNEL_SECRET =
  "MDL_FUNNEL_SECRET_2026_X7P9";

function getOrCreateLocalId(key) {
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;

    const value =
      crypto?.randomUUID?.() ||
      `${key}_${Date.now()}_${Math.random().toString(36).slice(2)}`;

    localStorage.setItem(key, value);
    return value;
  } catch {
    return null;
  }
}

function getOrCreateSessionId() {
  try {
    const key = "md_funnel_session_id";
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;

    const value =
      crypto?.randomUUID?.() ||
      `session_${Date.now()}_${Math.random().toString(36).slice(2)}`;

    sessionStorage.setItem(key, value);
    return value;
  } catch {
    return null;
  }
}

export function trackFunnelEvent(event, metadata = {}) {
  try {
    const params = new URLSearchParams(window.location.search);

    const payload = {
      secret: FUNNEL_SECRET,
      event,
      visitor_id: getOrCreateLocalId("md_funnel_visitor_id"),
      session_id: getOrCreateSessionId(),
      page: window.location.pathname + window.location.search,
      source:
        params.get("src") ||
        params.get("utm_source") ||
        "direct",
      campaign:
        params.get("campaign") ||
        params.get("utm_campaign") ||
        "",
      device: window.innerWidth <= 768 ? "mobile" : "desktop",
      language: navigator.language || "",
      referrer: document.referrer || "",
      metadata,
    };

    console.log("MDL funnel payload", payload);
    console.log("MDL funnel endpoint", FUNNEL_ENDPOINT);

    fetch(FUNNEL_ENDPOINT, {
      method: "POST",
      body: JSON.stringify(payload),
      keepalive: true,
      mode: "no-cors",
    }).catch((error) => {
      console.error("MDL FUNNEL ERROR", error);
    });
  } catch (error) {
    console.warn("[trackFunnelEvent] ignored", error);
  }
}